import { render, staticRenderFns } from "./ReportAlert.vue?vue&type=template&id=7b320adc"
import script from "./ReportAlert.vue?vue&type=script&lang=js"
export * from "./ReportAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports